import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import { MainLayout } from '@/components/layout';
import { subscriptionApi } from '@/api';
import { errorHandlingGlobal } from '@/utils/helper';
import { useParams } from 'react-router-dom';
import { useTranslate } from '@/locale';
import LanguagePreferenceBar from '../LanguagePreferenceBar';

const Unsubscribe = () => {
  const { translate } = useTranslate();
  const { subscriptionID } = useParams<{ subscriptionID: string }>();
  const [loading, setLoading] = useState<boolean>(false);

  const unsubscribeRequest = async () => {
    try {
      setLoading(true);
      await subscriptionApi.unsubscribe(subscriptionID);
    } catch (error) {
      errorHandlingGlobal(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    unsubscribeRequest();
  }, []);

  return (
    <MainLayout hideBanner>
      <MetaTags>
        <title>{translate('unsubscribe')}</title>
      </MetaTags>
      <LanguagePreferenceBar />
      {loading ? (
        <div style={{ padding: '1rem' }}>
          {translate('requesting')}
          ...
        </div>
      ) : (
        <div style={{ padding: '1rem' }}>
          {`${translate('unsubscribeSuccess')}!`}
        </div>
      )}
    </MainLayout>
  );
};

export default Unsubscribe;
